<template>
  <v-container fluid>
    <TableItems
      ref="table1"
      resource-collection-name="GoogleAccessTokenResourceListCollection"
      model-name-prop="User"
      :custom-delete-items="customDeleteItems"
      :custom-edit-item="customEditItem"
    >
      
    </TableItems>
    
  </v-container>
</template>
<style >
</style>

<script>
import TableItems from "@/views/TableItems.vue";
import mj_axios from "@/mj_axios.js";

export default {
  components: {TableItems },
  
  computed: {},
  data: () => ({apiUrl: "/api/user/google_access_token",
  
  }),

  methods: {
    customEditItem:function(item){
      this.$router.push({ name: "SchedaUser", params: { id: item.user_id } });
    },


      customDeleteItems:function(item){
            // if (item != null) return;
      this.$refs.table1.showLoader = true;
      this.$refs.table1.delete_confirm_dialog_show = false;

      let ids = [];
      //modalità singola
      if (item) {
        if (item.deleting) {
          return false;
        }
        item.deleting = true;
        ids.push(item.id);
      }
      //modalità array di selezionati
      else {
        ids = this.$refs.table1.selected.map(function (item) {
          return item.id;
        });
      }
      const axios_promise = mj_axios.delete(
        `/api/user/google_access_token/${JSON.stringify(ids)}?force_delete=true`
      );
      axios_promise
        .then(() => {
          for (let i = 0; i < ids.length; i++) {
            const id = ids[i];
              this.$refs.table1.items = this.$refs.table1.items.filter(item => {
                  if (item.id == id) {
                    item.Stato = {icon: "mdi-account-cancel", color:"grey"};
                  }
                  return item;
              });
          }
        })
        .catch(e => {
          this.$refs.table1.snack_bar_show = true;
          let message = "";
          if (e.response && e.response.data && e.response.data.message) {
            message = e.response.data.message;
          }
          this.$refs.table1.error_text = "Errore nel eliminazione dati " + message;
        })
        .then(() => {
          this.$refs.table1.showLoader = false;
          if (item) { item.deleting = false; }
          this.$refs.table1.selected = [];
          this.$refs.table1.serverItemsLength = this.$refs.table1.items.length;
        });
      
      }
  }
};
</script>



